import React from "react";

export default function Loader() {
  return (
    <div className="position-fixed loader top-0 left-0 bg-white w-100 h-100  d-flex flex-column justify-content-center align-items-center">
      <div
        className="spinner-grow-lg spinner-grow "
        role="status"
        style={{ color: "#5DC28A" }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}
